import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { SharedModule } from "@shared/shared.module";


@Component({
    selector: 'confirm-dialog',
    templateUrl:'./confirmDialog.component.html',
    styleUrls: ['../ConfirmDialog/confirm-dialog.component.scss'],
    imports: [
        SharedModule
    ],
})
export class SmallConfirmDialog {

    header : string;
    body : string;
    yesText : string;
    noText : string;

    constructor(public dialogRef: MatDialogRef<SmallConfirmDialog, boolean>, @Inject(MAT_DIALOG_DATA) public data: { title: string, subtitle: string, confirmText: string, refuseText: string}) {
         this.header = data.title;
         this.body = data.subtitle;
         this.yesText = data.confirmText;
         this.noText = data.refuseText;

    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

    onOkClick(): void {
        this.dialogRef.close(true);
    }

}

export function openSmallConfirmDialog(dialog : MatDialog, header : string, body: string, yesText : string, noText?: string): MatDialogRef<SmallConfirmDialog, boolean>{
    //console.log("Confirm dialofg", header , yesText)
    return dialog.open(SmallConfirmDialog, {
        disableClose: true,
        autoFocus: false,
        backdropClass: ["backdrop-blur"],
        data: { title : header , subtitle : body, confirmText: yesText, refuseText : noText }
    })
}